import React, { useEffect, useState, useRef } from "react";
import { auth } from "./firebase";
import { FirebaseAuthTypes } from "@react-native-firebase/auth";

type BaseAuthContainerProps = {
  children: React.ReactNode;
  loadingComponent: React.ComponentType;
  authComponent: React.ComponentType;
  onUserUpdate: (user: FirebaseAuthTypes.User) => Promise<any>;
  onUserLogout: () => void;
};

export const BaseAuthContainer = ({
  children,
  loadingComponent: LoadingComponent,
  authComponent: AuthComponent,
  onUserUpdate,
  onUserLogout,
}: BaseAuthContainerProps) => {
  const [user, setUser] = useState<null | FirebaseAuthTypes.User>();
  const [isLoading, setIsLoading] = useState(true);

  // Use refs to store the latest callback functions
  const onUserUpdateRef = useRef(onUserUpdate);
  const onUserLogoutRef = useRef(onUserLogout);

  // Update refs when props change
  useEffect(() => {
    onUserUpdateRef.current = onUserUpdate;
    onUserLogoutRef.current = onUserLogout;
  }, [onUserUpdate, onUserLogout]);

  useEffect(() => {
    return auth.onAuthStateChanged(
      (firebaseUser: FirebaseAuthTypes.User | null) => {
        setUser(firebaseUser);
        setIsLoading(false);
        if (firebaseUser) {
          return onUserUpdateRef.current(firebaseUser);
        } else {
          onUserLogoutRef.current();
        }
      },
    );
  }, []);

  if (isLoading) {
    return <LoadingComponent />;
  }

  if (user === null) {
    return <AuthComponent />;
  }

  return <>{children}</>;
};
